import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"

import {
  animationSettings,
  componentSettings,
  totalCycle,
} from "../../services/timelineService"

const SampleComponent = (props) => {
  // grab reference to containing div for animation
  const animEl = useRef(null)
  // add animations to timeline on component mount - timelineService to keep consistent with other timelines
  useEffect(() => {
    props.tl
      .to(
        animEl.current,
        {
          pointerEvents: "none",
          scale: componentSettings.scale,
          ease: "power4.in",
          duration: componentSettings.scaleDuration,
        },
        props.tl.getChildren().length === 0 ? null : `-=${animationSettings.overlapDuration}`
      )
      .to(
        animEl.current,
        {
          opacity: 1,
          ease: "power4.in",
          duration: componentSettings.opacityDuration,
          onStart: () => {
            if(props.heroTl){
              props.heroTl.play()
            }
          },
        },
        "<"
      )
      .to(
        animEl.current,
        {
          opacity: 0,
          ease: "power4.out",
          duration: componentSettings.opacityDuration,
          // onStart: () => {
          //   if(props.heroTl){
          //     props.heroTl.play()
          //   }
          // },
        },
        `<${componentSettings.opacityOutOffset}`
      )
      .to(animEl.current, {
        pointerEvents: "none", // pointerEvents: 'none'
        opacity: 0,
        scale: 1,
      })
  }, [])

  return (
    <div ref={animEl} className='card' id={props.id ? props.id : null}>
      {props.children}
    </div>
  )
}

SampleComponent.propTypes = {
  id: PropTypes.string,
  children: PropTypes.element.isRequired,
  tl: PropTypes.object.isRequired,
  // onComplete: PropTypes.func,
}

export default SampleComponent
